module.exports = __webpack_public_path__ + "static/media/grit-leadership-logo-white.4442de71.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/grit-leadership-logo-white.svg
// module id = ./src/assets/grit-leadership-logo-white.svg
// module chunks = 2